import axios from "axios"

export default{
    async Get(data){
        const response = await axios.get(`/api/inflationoperations/getbytype/${data}`)
        return response
    },
    async GetLastTwoYears(){
        const response = await axios.get(`/api/inflationoperations/lasttwoyears/getbytype`)
        return response
    },
    async UploadFile(data){
        const response = await axios.post(`/api/inflationoperations/uploadfile`,data,{
            headers: { "Content-Type": "multipart/form-data" },
        })
        return response
    },
    async GetSampleExcel(){
        const response = await axios.get(`/api/inflationoperations/downloadsamplefile`,{
            responseType: 'blob',
        })
        return response
    }
}